import React, { type FC } from 'react'
import { FeedTabs } from 'pages/native/userFeed/types'

import classes from './TabHeadingItem.module.scss'

type TabHeadingItemProps = {
  tab: FeedTabs
  isActive: boolean
  onClick: () => void
}

export const TabHeadingItem: FC<TabHeadingItemProps> = ({
  tab,
  isActive,
  onClick
}) => {
  const mergedClasses = `${classes.Container} ${
    isActive ? classes.ActiveTab : undefined
  }`
  return (
    <div className={mergedClasses} onClick={onClick}>
      {tab}
    </div>
  )
}
